import { render, staticRenderFns } from "./SummaryDairyCard.vue?vue&type=template&id=2f11b35f&scoped=true"
import script from "./SummaryDairyCard.vue?vue&type=script&lang=ts"
export * from "./SummaryDairyCard.vue?vue&type=script&lang=ts"
import style0 from "./SummaryDairyCard.vue?vue&type=style&index=0&id=2f11b35f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11b35f",
  null
  
)

export default component.exports